import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Image from 'components/Image';
import React, { useState } from 'react';
import communityImg from '../../images/community.svg';
import LoginButton from '../Header/LoginButton';

const useStyles = makeStyles()(theme => ({
  card: {
    background: theme.palette.mode === 'dark' ? '#343F44' : '#F5F8FA',
  },
}));

export default function JoinCard({ isFullText, isBgShade, text }) {
  const [signUpOpen, setSignUpOpen] = useState(false);

  const { classes } = useStyles();

  return (
    <>
      <Card className={isBgShade ? classes.card : undefined}>
        <CardActionArea className="h-100" onClick={() => setSignUpOpen(true)}>
          <CardContent>
            <div className="text-center">
              <Typography gutterBottom variant="h4" className="pt-2">
                {isFullText ? text : `Create an account and ${text}`}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                className="mt-3 mb-4"
                onClick={() => setSignUpOpen(true)}
              >
                Join the community
              </Button>
              <Image
                className="img-fluid"
                src={communityImg}
                alt="alternative"
              />
            </div>
          </CardContent>
        </CardActionArea>
      </Card>
      {signUpOpen && (
        <LoginButton
          open={signUpOpen}
          hideButtons
          onClickClose={() => setSignUpOpen(false)}
          text=" and join your favorite travel communities"
        />
      )}
    </>
  );
}
